import React from "react";
import { useTranslation } from 'react-i18next';

function FooterBottom () {

    const { t } = useTranslation();

        return (
            <>
                <div className="footer_bottom">
                    <div className="">
                        <div className="row align-items-center justify-content-center text-center">
                            <div className="col-lg-3 col-md-12 col-sm-12">
                                <a href="https://www.dreamcodesoft.com" target="_blank" rel="noreferrer" className="f-logo"><img src={require("./../../img/logo-blue.png")} alt=""  width="200"/></a>
                            </div>
                            <div className="col-lg-3 col-md-12 col-sm-12">
                                <a href={require ("../../Doc/Tratamiento_de_Datos_Dreamcode.pdf")} className='f_600 m_color' download="Tratamiento_de_Datos_Dreamcode.pdf">{t("footer.privacyPolicy")}</a>
                            </div>
                            <div className="col-lg-3 col-md-12 col-sm-12">
                                <a href="mailto:info@dreamcodesoft.com"  target="_blank" rel="noreferrer" className="f_600 m_color">info@dreamcodesoft.com</a>
                            </div>
                            <div className="col-lg-3 col-md-12 col-sm-12">                                
                                <ul className="social_icon list-inline row justify-content-center">
                                    <li className="social_iconos "><a href="https://www.linkedin.com/company/dreamcode-software/" target="_blank" rel="noreferrer"><i className="ti-linkedin"></i></a></li>
                                    <li className="social_iconos "><a href="https://www.instagram.com/dreamcode_software/" target="_blank" rel="noreferrer"><i className="ti-instagram"></i></a></li>
                                    <li className="social_iconos "><a href="https://www.facebook.com/dreamcodesoft" target="_blank" rel="noreferrer"><i className="ti-facebook"></i></a></li>
                                    <li className="social_iconos "><a href="https://www.youtube.com/channel/UC2cXutvW1QF4q9NhFHiUZPg" target="_blank" rel="noreferrer"><i className="ti-youtube"></i></a></li>
                                </ul>  
                            </div>
                        </div>
                    </div>
                </div>
            </>              
        );
    }

export default FooterBottom;